// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* MOBILE OPTIMIZATIONS (Max Width 600px) */
@media (max-width: 600px) {
  /* Compress Tables */
  .MuiTableCell-root {
    padding: 6px 10px !important;
    font-size: 0.65rem !important;
  }
  
  /* Compress TextFields */
  .MuiOutlinedInput-root {
    font-size: 0.75rem !important;
  }
  
  /* Optimize Table Headers */
  .MuiTableHead-root .MuiTableCell-root {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
    font-size: 0.6rem !important;
  }

  /* Tighten Container padding */
  .MuiContainer-root {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }

  /* Force Tables to Scroll Horizontally */
  .MuiTableContainer-root {
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch;
  }

  /* Make Dialogs more responsive */
  .MuiDialog-paper {
    margin: 12px !important;
    width: calc(100% - 24px) !important;
    max-width: 100% !important;
  }
}

/* Scrollbar styling for better look on mobile */
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 10px;
}
::-webkit-scrollbar-track {
  background: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA,2CAA2C;AAC3C;EACE,oBAAoB;EACpB;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA,wBAAwB;EACxB;IACE,6BAA6B;EAC/B;;EAEA,2BAA2B;EAC3B;IACE,2BAA2B;IAC3B,8BAA8B;IAC9B,4BAA4B;EAC9B;;EAEA,8BAA8B;EAC9B;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA,wCAAwC;EACxC;IACE,2BAA2B;IAC3B,iCAAiC;EACnC;;EAEA,iCAAiC;EACjC;IACE,uBAAuB;IACvB,mCAAmC;IACnC,0BAA0B;EAC5B;AACF;;AAEA,gDAAgD;AAChD;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* MOBILE OPTIMIZATIONS (Max Width 600px) */\n@media (max-width: 600px) {\n  /* Compress Tables */\n  .MuiTableCell-root {\n    padding: 6px 10px !important;\n    font-size: 0.65rem !important;\n  }\n  \n  /* Compress TextFields */\n  .MuiOutlinedInput-root {\n    font-size: 0.75rem !important;\n  }\n  \n  /* Optimize Table Headers */\n  .MuiTableHead-root .MuiTableCell-root {\n    padding-top: 8px !important;\n    padding-bottom: 8px !important;\n    font-size: 0.6rem !important;\n  }\n\n  /* Tighten Container padding */\n  .MuiContainer-root {\n    padding-left: 12px !important;\n    padding-right: 12px !important;\n  }\n\n  /* Force Tables to Scroll Horizontally */\n  .MuiTableContainer-root {\n    overflow-x: auto !important;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  /* Make Dialogs more responsive */\n  .MuiDialog-paper {\n    margin: 12px !important;\n    width: calc(100% - 24px) !important;\n    max-width: 100% !important;\n  }\n}\n\n/* Scrollbar styling for better look on mobile */\n::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n}\n::-webkit-scrollbar-thumb {\n  background: #d1d5db;\n  border-radius: 10px;\n}\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
